import {createSelector} from 'reselect';
import lodashGet from 'lodash/get';
import {getOxygenMappings} from './configuration-selectors';
import {AdminPermissionsV2Actions} from '../../constants/issues-admin';

export const getCurrentUserPermissions = state => state.currentUserPermissions;
export const getIsLoadingCurrentUserPermissions = createSelector(
  getCurrentUserPermissions,
  ({loading}) => loading
);

export const getCurrentUser = createSelector(
  getCurrentUserPermissions,
  currentUser => currentUser?.attributes
);

export const getCurrentUserId = createSelector(
  getCurrentUser,
  attributes => attributes?.id
);

export const getCurrentUserInMcFormat = createSelector(
  getCurrentUserId,
  getOxygenMappings,
  (currentUserId, oxygen) => oxygen.users[currentUserId] || {}
);

export const isProjectAdmin = createSelector(
  getCurrentUserPermissions,
  user => lodashGet(user, 'attributes.isProjectAdmin', false)
);

export const canManageTemplates = createSelector(
  getCurrentUserPermissions,
  user => lodashGet(user, 'attributes.canManageTemplates', false)
);

export const canCreateIssue = createSelector(
  getCurrentUserPermissions,
  currentUser => {
    if (lodashGet(currentUser, 'attributes.qualityIssues.new')) {
      // TODO - remove when clearing `USERS_ME_V2` FF.
      return true;
    }
    return lodashGet(currentUser, 'attributes.permissionLevels', []).includes(AdminPermissionsV2Actions.CREATE);
  }
);
